import React from "react";
// import Select from "react-select";
// const services = [
//   { value: "haircut", label: "Haircut" },
//   { value: "spa", label: "SPA" },
// ];
const Offerdetails = () => {
  return (
    <section className="content mb-5">
      <div className="container-fluid">
        <div className="row titlepad publsih-sticky">
          <div className="col-md-12">
            <div className="mt-3 mb-3">
              <div className="dashbed-border-bottom"></div>
            </div>
            <div className="row">
              <div className="col-sm-8">
                <h4>Offer Name</h4>
                <p className="page-sub-head">Add/Edit Offer</p>
              </div>
              <div className="col-md-4 text-sm-right mt-2">
                <a
                  href="javascript:history.back()"
                  className="btn-md px-3 py-2 btn-primary"
                >
                  <i class="fa-regular fa-square-check" aria-hidden="true"></i>
                  Publish
                </a>
                <a
                  href="javascript:history.back()"
                  className="btn-md px-3 py-2 btn-secondary"
                >
                  <i className="fa fa-chevron-circle-left"></i> Cancel
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-8">
            <div className="tabData mt-4">
              <h6>Enter the details below for create/edit Offers</h6>
              <div className="mt-2 mb-2">
                <div className="dashbed-border-bottom"></div>
              </div>
              <div className="pb-4">
                <div className="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>
                        Select Branch <span class="text-danger">*</span>
                      </label>
                      <select class="form-control selectpicker">
                        <option value="">Select </option>
                        <option value="1">Noida - 135</option>
                        <option value="2">South Delhi</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>
                        Coupon Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Coupon Name"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>
                        Coupon Code <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Coupon Code"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Discription</label>
                      <textarea
                        rows="1"
                        type="text"
                        className="form-control"
                        placeholder="Enter Discription here"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>
                        Discount type <span className="text-danger">*</span>
                      </label>
                      <select className="form-control selectpicker">
                        <option value="">Select </option>
                        <option value="1">Flat/15%</option>
                        <option value="2">Flat/25%</option>
                        <option value="3">Flat/50%</option>
                      </select>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label>
                        Discount value <span className="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Enter Discount value"
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label>
                        Currency <span className="text-danger">*</span>
                      </label>
                      <select className="form-control selectpicker">
                        <option value="">Select </option>
                        <option value="1">INR</option>
                        <option value="2">Dollar</option>
                        <option value="2">Dhram</option>
                        <option value="2">Euro</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Minimum order value</label>
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Enter Minimum order"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Maximum Discount (Cap)</label>
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Enter Maximum discount"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Usage limit per user</label>
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Enter Usage limit"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Total Usage limit</label>
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Enter Total Usage limit"
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label>
                        Start date <span className="text-danger">*</span>
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        placeholder="Start Date"
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label>
                        Start End <span className="text-danger">*</span>
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        placeholder="Start End"
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label>
                        Select Services <span className="text-danger">*</span>
                      </label>
                      <select className="form-control selectpicker">
                        <option value="1">Draft</option>
                        <option value="2">Active</option>
                        <option value="3">Expired</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card">
              <div className="card-header" id="headingOne">
                <h5 className="mb-0">
                  <button className="btn btn-link text-black shadow-none pl-0 pb-0 staturightghead">
                    Status Update
                  </button>
                </h5>
              </div>

              <div className="card-body">
                <div>
                  <label className="logCheck mb-3">
                    <input type="radio" checked name="statusupdate" />
                    <div>Active</div>
                    <span className="checkmark"></span>
                  </label>

                  <label className="logCheck mb-0">
                    <input type="radio" name="statusupdate" />
                    <div>InActive</div>
                    <span className="checkmark"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Offerdetails;
